export default "__VITE_ASSET__C6Mbz1yi__"